/* tslint:disable */
import {
  Player,
  Game,
  SocialAccount,
  GamePlayerEmoji
} from '../index';

declare var Object: any;
export interface GamePlayerInterface {
  "gameId"?: any;
  "playerId"?: any;
  "socialAccountId"?: any;
  "isWinner"?: boolean;
  "points"?: number;
  "prize"?: any;
  "prizeId"?: string;
  "locationOutOfRange"?: boolean;
  "isAutoMatch"?: boolean;
  "id"?: any;
  player?: Player;
  game?: Game;
  socialAccount?: SocialAccount;
  playerEmojis?: GamePlayerEmoji[];
}

export class GamePlayer implements GamePlayerInterface {
  "gameId": any;
  "playerId": any;
  "socialAccountId": any;
  "isWinner": boolean;
  "points": number;
  "prize": any;
  "prizeId": string;
  "locationOutOfRange": boolean;
  "isAutoMatch": boolean;
  "id": any;
  player: Player;
  game: Game;
  socialAccount: SocialAccount;
  playerEmojis: GamePlayerEmoji[];
  constructor(data?: GamePlayerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `GamePlayer`.
   */
  public static getModelName() {
    return "GamePlayer";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of GamePlayer for dynamic purposes.
  **/
  public static factory(data: GamePlayerInterface): GamePlayer{
    return new GamePlayer(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'GamePlayer',
      plural: 'GamePlayers',
      path: 'GamePlayers',
      idName: 'id',
      properties: {
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "socialAccountId": {
          name: 'socialAccountId',
          type: 'any'
        },
        "isWinner": {
          name: 'isWinner',
          type: 'boolean',
          default: false
        },
        "points": {
          name: 'points',
          type: 'number',
          default: 0
        },
        "prize": {
          name: 'prize',
          type: 'any'
        },
        "prizeId": {
          name: 'prizeId',
          type: 'string'
        },
        "locationOutOfRange": {
          name: 'locationOutOfRange',
          type: 'boolean',
          default: false
        },
        "isAutoMatch": {
          name: 'isAutoMatch',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
        socialAccount: {
          name: 'socialAccount',
          type: 'SocialAccount',
          model: 'SocialAccount',
          relationType: 'belongsTo',
                  keyFrom: 'socialAccountId',
          keyTo: 'id'
        },
        playerEmojis: {
          name: 'playerEmojis',
          type: 'GamePlayerEmoji[]',
          model: 'GamePlayerEmoji',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'gamePlayerId'
        },
      }
    }
  }
}
